<template>
  <div
    v-if="critereRecherche"
    class="columns is-multiline is-marginless is-main-content is-paddingless">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 is-marginless overflow-auto hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <qd-notification type="is-primary" v-if="tiers" class="is-marginless pd-6px"
                          @close="deleteTiersId()">
            {{ $t('listeFactures.filtre.tiers', { client: tiers.nomCommercial }) }}
          </qd-notification>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listePlanMedia.filtre.code')">
            <b-input v-model="critereRecherche.code"></b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                        :label="$t('listePlanMedia.filtre.statut')"
                        :items="constantes.PM_STATUS_TYPE"
                        v-model="critereRecherche.statut">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listePlanMedia.filtre.produits')">
            <qd-taginput
              v-model="produitsSelected"
              icon="magnify"
              :data="filteredProduits"
              autocomplete
              type="is-primary"
              :loading="isFetchingProduits"
              field="reference"
              @typing="getfilteredProduits">
              <template slot-scope="props">
                {{ props.option.reference }} - {{ props.option.libelle }}
              </template>
              <template slot="empty">
                <div v-if="!isFetchingProduits">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeFactures.filtre.parutions')">
            <qd-taginput
              v-model="parutionsSelected"
              :data="filteredParutions"
              :loading="isFetchingParutions"
              icon="magnify"
              type="is-primary"
              field="code"
              autocomplete
              @typing="getfilteredParutions">
              <template slot-scope="props">
                {{ `${props.option.code} - ${props.option.nomParution}` }}
              </template>
              <template slot="empty">
                <div v-if="!isFetchingParutions">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0 mgt-10px">
          <user-tag-input
            v-model="commercialSelected"
            :label="$t('listePlanMedia.filtre.commercial')"
            :blocked="userIsCommercialBlocked"
            :items="listeCommercial">
          </user-tag-input>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('general.button.apply')}}
      </button>
      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('general.button.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import { getAll as getAllProduits } from '@/api/produit/index';
import { getAll as getAllParutions } from '@/api/presse/parution';
import messageErreur from '@/services/general/messageErreur';
import genererCritereRecherche from '@/services/planMedia/genererCritereRecherche';
import { SET_CRITERE_RECHERCHE } from '@/store/modules/planMedia-mutation-type';
import { PM_STATUS_TYPE } from '@/configuration/bodac/planMedia/planMediaConfig';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import { get as getTiers } from '@/api/tiers/index';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import userTagInput from '@/components/general/tagInput/userTagInput';
import initialUsers from '@/services/general/filters/filterinitUsers';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';

const PlanMedia = createNamespacedHelpers('planMedia');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  data() {
    return {
      critereRecherche: null,
      filteredTagsStatut: [],
      produitsSelected: [],
      filteredProduits: [],
      isFetchingProduits: false,
      parutionsSelected: [],
      isFetchingParutions: false,
      filteredParutions: [],
      constantes: {
        PM_STATUS_TYPE,
      },
      tiers: null,
      listeCommercial: [],
      commercialSelected: [],
    };
  },
  components: {
    libelleTagInput,
    userTagInput,
  },
  computed: {
    ...PlanMedia.mapGetters({
      critereRechercheFromStore: 'criteresRecherche',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    blocageFiltreCommercial() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
      );
    },
    userIsCommercial() {
      return this.user.profil === COMMERCIAL;
    },
    userIsCommercialBlocked() {
      return (this.userIsCommercial && this.blocageFiltreCommercial);
    },
  },
  methods: {
    ...PlanMedia.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE,
    }),
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
    }),
    getfilteredProduits: debounce(async function getProduits(search) {
      this.filteredProduits = [];
      if (!search) return;
      this.isFetchingProduits = true;
      try {
        const produits = (await getAllProduits(
          {
            query: {
              auto: search,
            },
          },
        )).data.result.items;
        this.filteredProduits = produits.filter((produit) => {
          return !this.produitsSelected.map(
            produitSelected => produitSelected.id,
          ).includes(produit.id);
        });
        this.isFetchingProduits = false;
      } catch (e) {
        this.isFetchingProduits = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    getfilteredParutions: debounce(async function getParutions(search) {
      this.filteredParutions = [];
      if (!search) return;
      this.isFetchingParutions = true;
      try {
        const parutions = (await getAllParutions({
          query: {
            auto: search,
            societeId: this.societeActiveId,
          },
        })).data.result.items;
        this.filteredParutions = parutions.filter((produit) => {
          return !this.parutionsSelected.map(p => p.id).includes(produit.id);
        });
        this.isFetchingParutions = false;
      } catch (e) {
        this.isFetchingParutions = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    deleteTiersId() {
      this.tiers = null;
      this.critereRecherche.tiersId = genererCritereRecherche().tiersId;
    },
    async viderCritere() {
      const critereRecherche = genererCritereRecherche();
      this.critereRecherche = critereRecherche;
      await updateCritereWithParametreInterne(this.critereRecherche);
      this.commercialSelected = this.critereRecherche.commercialId.map(id => {
        return this.listeCommercial.find(c => c.id === id) ?? {};
      });
      this.produitsSelected = [];
      this.parutionsSelected = [];
    },
    appliquerCritere() {
      this.critereRecherche.produitsIds = this.produitsSelected;
      this.critereRecherche.parutionsIds = this.parutionsSelected;
      this.critereRecherche.commercialId = this.commercialSelected.map((c) => {
        return c.id;
      });
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
      try {
        await this.loadParametreUtilisateur();
        await updateCritereWithParametreInterne(this.critereRecherche);
        if (this.critereRecherche.tiersId.length > 0) {
          this.tiers = (await getTiers(this.critereRecherche.tiersId[0])).data.result;
        }
        const users = this.parametre(typesParametres.PARAMETRES_KEYS.utilisateur)
          .filter(u => u.actif);
        this.listeCommercial = initialUsers(users, [DIRECTEUR_COMMERCIAL, COMMERCIAL]);
        this.commercialSelected = this.listeCommercial.filter((c) => {
          return this.critereRecherche.commercialId.includes(c.id);
        });
        await this.loadParametresInterne([
          typesParametres.PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key]);
        this.produitsSelected = this.critereRecherche.produitsIds;
        this.parutionsSelected = this.critereRecherche.parutionsIds;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw (e);
      }
    },
  },
  async mounted() {
    await this.initializeFiltre();
  },
};
</script>
